// extracted by mini-css-extract-plugin
module.exports = {"root":"MarketingIsland_root__d5kxt"};